<div class="invite-layout">

  <!-- LEFT PANEL — Invitation Dossier -->
  <div class="invite-branding">
    <div class="glow-1"></div>
    <div class="glow-2"></div>
    <div class="particle"></div>
    <div class="particle"></div>
    <div class="particle"></div>
    <div class="particle"></div>
    <div class="particle"></div>
    <div class="particle"></div>

    <div class="brand-z">
      <div class="brand-sm">d<span class="ai">AI</span>rector</div>

      @if (state !== 'loading' && state !== 'error' && state !== 'expired') {
        <div class="org-card">
          <!-- Org identity -->
          <div class="org-card-top">
            <div class="org-logo-ring">
              {{ orgInitial }}
              <div class="logo-pulse-ring"></div>
            </div>
            <div class="org-id">
              <div class="org-name">{{ orgName }}</div>
              <div class="org-url">{{ orgUrl }}</div>
            </div>
          </div>

          <!-- Invited by -->
          <div class="invite-detail">
            <div class="detail-icon amber">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div class="detail-info">
              <div class="detail-label">Invited by</div>
              <div class="detail-value">{{ invitedByName }}</div>
              @if (invitedByRole) {
                <div class="detail-sub">{{ invitedByRole }}</div>
              }
            </div>
          </div>

          <!-- Your role -->
          <div class="invite-detail">
            <div class="detail-icon cyan">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <div class="detail-info">
              <div class="detail-label">Your Role</div>
              <div style="margin-top: 2px;">
                <span class="role-badge"><span class="dot"></span> {{ userRole }}</span>
              </div>
            </div>
          </div>

          <!-- Team size -->
          @if (teamCount > 0) {
            <div class="invite-detail">
              <div class="detail-icon purple">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </div>
              <div class="detail-info">
                <div class="detail-label">Team</div>
                <div class="detail-value">{{ teamCount }} members</div>
                @if (activeProjects > 0) {
                  <div class="detail-sub">{{ activeProjects }} active projects</div>
                }
              </div>
            </div>
          }

          <!-- Invitation Journey Pipeline -->
          <div class="invite-journey">
            <div class="journey-node">
              <div class="journey-dot done">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <div class="journey-label">Invited</div>
            </div>
            <div class="journey-connector" [class.done]="state === 'form' || state === 'processing'" [class.active]="state === 'success' || state === 'accepted'"></div>
            <div class="journey-node">
              <div class="journey-dot" [class.active]="state === 'form' || state === 'processing'" [class.done]="state === 'success' || state === 'accepted'">
                @if (state === 'success'  || state === 'accepted') {
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                } @else {
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/></svg>
                }
              </div>
              <div class="journey-label">Accept</div>
            </div>
            <div class="journey-connector" [class.active]="state === 'success' || state === 'accepted'"></div>
            <div class="journey-node">
              <div class="journey-dot" [class.active]="state === 'success' || state === 'accepted'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>
              </div>
              <div class="journey-label">Onboarded</div>
            </div>
          </div>

          <!-- Capabilities -->
          <div class="capabilities">
            <div class="cap-label">What you'll be able to do</div>
            <div class="cap-grid">
              <div class="cap-card">
                <div class="cap-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                </div>
                <span class="cap-text">Upload Versions</span>
              </div>
              <div class="cap-card">
                <div class="cap-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
                </div>
                <span class="cap-text">Leave Feedback</span>
              </div>
              <div class="cap-card">
                <div class="cap-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                </div>
                <span class="cap-text">Manage Assets</span>
              </div>
              <div class="cap-card">
                <div class="cap-icon amber">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                </div>
                <span class="cap-text">Track Progress</span>
              </div>
            </div>
          </div>

          <!-- Tagline -->
          <div class="invite-tagline">
            <div class="tagline-text">
              <span class="tagline-accent">Cinematic Precision</span> at <strong>AI Scale</strong>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- RIGHT PANEL — Form / States -->
  <div class="invite-form-panel">

    <!-- LOADING STATE -->
    @if (state === 'loading') {
      <div class="form-card">
        <div class="auth-hdr">
          <div class="loading-spinner"></div>
          <h2 class="auth-title">Loading invitation...</h2>
          <p class="auth-sub">Please wait while we fetch your invitation details.</p>
        </div>
      </div>
    }

    <!-- FORM STATE -->
    @if (state === 'form') {
      <div class="form-card">
        <div class="auth-hdr">
          <h2 class="auth-title">Join {{ orgName }}</h2>
          <p class="auth-sub">
            @if (isExistingUser) {
              Welcome back! Accept the invite to join <strong>{{ orgName }}</strong>.
            } @else {
              Create your account to join <strong>{{ orgName }}</strong> on dAIrector.
            }
          </p>
        </div>

        <!-- Email (read-only) -->
        <div class="fg stagger-1">
          <label class="fl">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
            Email
          </label>
          <div class="fw">
            <input type="email" class="fi ro" [value]="userEmail" readonly>
            <span class="fi-icon lock">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </span>
          </div>
        </div>

        @if (!isExistingUser) {
          <!-- Full Name -->
          <div class="fg stagger-2">
            <label class="fl">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              First Name
            </label>
            <div class="fw">
              <input type="text" class="fi" placeholder="Enter your first name" [(ngModel)]="firstname">
            </div>
          </div>

           <div class="fg stagger-2">
            <label class="fl">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              Last Name
            </label>
            <div class="fw">
              <input type="text" class="fi" placeholder="Enter your last name" [(ngModel)]="lastname">
            </div>
          </div>
         
        }

        <!-- Accept CTA -->
        <button class="btn-cta stagger-4" (click)="acceptInvite()">
          @if (isExistingUser) {
            Accept & Join {{ orgName }}
          } @else {
            Create Account & Join
          }
        </button>

        <div class="divr stagger-5">
          <div class="divr-line"></div>
          <span class="divr-txt">or sign in with</span>
          <div class="divr-line"></div>
        </div>

        <!-- SSO -->
        <div class="sso-row stagger-6">
          <button class="btn-sso g">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Google
          </button>
          <button class="btn-sso m">
            <svg viewBox="0 0 24 24" width="16" height="16"><path fill="#0078D4" d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zM24 11.4H12.6V0H24v11.4z"/></svg>
            Microsoft
          </button>
        </div>

        <!-- Trust badge -->
        <div class="trust-badge stagger-7">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          256-bit encrypted
          <span class="trust-sep"></span>
          SOC 2 compliant
        </div>

        <!-- Decline -->
        <div class="decline-row stagger-8">
          @if (!showDeclineConfirm) {
            <button class="decline-btn" (click)="showDecline()">Decline this invitation</button>
          } @else {
            <div class="decline-confirm">
              <p class="decline-confirm-txt">Are you sure you want to decline the invite from <strong>{{ orgName }}</strong>?</p>
              <div class="decline-actions">
                <button class="d-btn red" (click)="confirmDecline()">Yes, decline</button>
                <button class="d-btn ghost" (click)="cancelDecline()">Cancel</button>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- PROCESSING STATE -->
    @if (state === 'processing') {
      <div class="form-card">
        <div class="auth-hdr">
          <div class="loading-spinner"></div>
          <h2 class="auth-title">Setting up your workspace...</h2>
          <p class="auth-sub">Please wait while we configure your access to <strong>{{ orgName }}</strong>.</p>
        </div>
      </div>
    }

    <!-- SUCCESS STATE -->
    @if (state === 'success') {
      <div class="form-card">
        <div class="success-state active">
          <div class="success-ring-wrap">
            <div class="success-ring">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div class="success-wave"></div>
            <div class="success-wave"></div>
            <div class="success-ring-pulse"></div>
          </div>

          <h2 class="success-ttl">Welcome to {{ orgName }}!</h2>
          <p class="success-sub">You're now a member of <strong>{{ orgName }}</strong> as {{ userRole }}.</p>

          <button class="btn-enter" (click)="enterWorkspace()">
            Enter Workspace
            <svg class="arr" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </button>
        </div>
      </div>
    }

     @if (state === 'accepted') {
      <div class="form-card">
        <div class="success-state active">
          <div class="success-ring-wrap">
            <div class="success-ring">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div class="success-wave"></div>
            <div class="success-wave"></div>
            <div class="success-ring-pulse"></div>
          </div>

          <h2 class="success-ttl">Welcome to {{ orgName }}!</h2>
          <p class="success-sub">You have already joined <strong>{{ orgName }}</strong> as {{ userRole }}.</p>

          <button class="btn-enter" (click)="goToLogin()">
            Enter Workspace
            <svg class="arr" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </button>
        </div>
      </div>
    }

    <!-- DECLINED STATE -->
    @if (state === 'declined') {
      <div class="form-card">
        <div class="declined-state">
          <div class="declined-ring">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ff3d71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
          <h2 class="declined-ttl">Invitation Declined</h2>
          <p class="declined-sub">You've declined the invitation to join {{ orgName }}.</p>
          <p class="declined-hint">Changed your mind? Ask <strong>{{ invitedByName }}</strong> to send a new invitation.</p>
        </div>
      </div>
    }

    <!-- ERROR STATE -->
    @if (state === 'error') {
      <div class="form-card">
        <div class="declined-state">
          <div class="declined-ring">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ff3d71" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <h2 class="declined-ttl">Invalid Invitation</h2>
          <p class="declined-sub">This invitation link is invalid or has already been used.</p>
          <button class="btn-cta" style="max-width: 200px; margin: 0 auto;" (click)="goToLogin()">Go to Login</button>
        </div>
      </div>
    }

    <!-- EXPIRED STATE -->
    @if (state === 'expired') {
      <div class="form-card">
        <div class="declined-state">
          <div class="declined-ring" style="background: rgba(255,170,0,0.12);">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffaa00" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </div>
          <h2 class="declined-ttl">Invitation Expired</h2>
          <p class="declined-sub">This invitation link has expired. Please ask the team admin to resend the invitation.</p>
          <button class="btn-cta" style="max-width: 200px; margin: 0 auto;" (click)="goToLogin()">Go to Login</button>
        </div>
      </div>
    }

  </div>

  <!-- FOOTER -->
  <div class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <span class="footer-logo">d<span class="ai">AI</span>rector</span>
        <span class="footer-div"></span>
        <span class="footer-copy">&copy; 2025 dAIrector</span>
      </div>
      @if (expiresIn && state === 'form') {
        <div class="footer-center">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          Expires in <span class="expiry-val">{{ expiresIn }}</span>
        </div>
      }
      <div class="footer-status">
        <span class="footer-dot"></span>
        Secure connection
      </div>
    </div>
  </div>

</div>
